import { Box, Text } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorTokens, variables } from '../variables';

export const Container = styled(Box)<{ $bgcolor?: string }>`
  display: block;
  align-items: center;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
  background-color: ${({ $bgcolor }) => $bgcolor ?? colorTokens.background.light};
  min-height: 70px;
  padding: 1rem 0;

  ${variables.mediaQuery.lessThan('desktop')`
    top: 100px;
    .MuiBox-root {
      flex-wrap: wrap;
    }
  `}

  ${variables.mediaQuery.lessThan('tablet')`  
    .MuiBox-root {
      margin-right: 0;
      gap: 8px;
    }
  `}

   @media (max-height: 400px) {
    position: relative;
    top: 0;
  }
`;

export const TitleText = styled(Text)`
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  color: ${colorTokens.text.dark};
  font-weight: 700;

  @media (max-width: 400px) {
    font-size: 1.2rem;
    line-height: 1.3;
  }
`;
